import { ProjectCommunicationService } from '../communication/project-comms.service';

import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ProgressPopupDialogComponent } from './progress-sidebar/progress-popup/progress-popup.component';
import { ValidationSectionName } from '../models/data-structures/project-validation';
import { ValidationService } from '../helper/validation/validation.service';

@Injectable()
export class ValidateGuard  {

  constructor(private projectCommService: ProjectCommunicationService,
              private validationService: ValidationService,
              private dialog: MatDialog) {
  }

  canActivate() {
    if (!this.projectCommService.projectLoadedValue) {
      return false;
    }
    const projectValidation = this.validationService.getProjectValidation();

    if (projectValidation.complete) {
      return true;
    } else {
      this.dialog.open(ProgressPopupDialogComponent, {
        width: '800px',
        height: '85vh',
        data: {
          projectValidation: projectValidation,
          section: ValidationSectionName.All,
          onlyShowInvalid: true
        }
      });
      return false;
    }
  }
}
